import React from "react";
import useSlug from "../../hooks/useSlug";
import NavbarMastercard from "./navbarMastercard";
import Navigation from "./navigation";

const Navbar = () => {
  const slug = useSlug();
  switch (slug) {
    case "mastercard":
      return <NavbarMastercard />;
    default:
      return <Navigation />;
  }
};

export default Navbar;
